import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import * as React from 'react';
import { ExternalLink } from '../LinkDom';
import { useChainId } from 'wagmi';
import CloseImg from '../../assets/image/model/close@2x.png';
import JumpImg from '../../assets/image/model/jump@2x.png';
import { walletConfig } from '../walletManager/walletConfig';
const ConfirmOrLoadingWrapper = styled.div `
  width: 540rem;
  height: 286rem;
  box-sizing: border-box;
  padding: 0 48rem;
  background: #1C1C20;
  font-family: var(--netx-font);
  border-radius: 24rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: min(343rem, calc(100vw - 32rem));
    height: auto;
    min-height: 182rem;
    border-radius: 16rem;
    padding: 32rem 24rem 28rem;
    margin: 0 auto; 
  `};
  .content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .text {
    max-width: 300rem;
    font-family: var(--netx-font);
    font-weight: 300;
    font-size: 12rem;
    color: #A2A2A2;
    line-height: 16rem;
    text-align: center;
    ${({ theme }) => theme.mediaWidth.upToSmall `
      width: 100%;
      height: fit-content;
      max-width: 236rem;
      font-size: 11rem;
      line-height: 16rem;
      text-align: center;
      font-style: normal;
    `};

  }
  .scanText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    a{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28rem;
      padding: 0 14rem;
      border: 1rem solid rgba(38, 111, 255, 0.72);
      border-radius: 16rem;
      color: #FFFFFF;
      font-size: 12rem;
      font-weight: 500;
      line-height: 16rem;
      text-decoration: none;
      ${({ theme }) => theme.mediaWidth.upToSmall `
        height: 24rem;
        padding: 0 12rem;
        border-radius: 14rem;
        font-size: 10rem;
        line-height: 14rem;
      `};
    }
  }
`;
const CloseIconButton = styled.button `
  width: 32rem;
  height: 32rem;
  padding: 0;
  position: absolute;
  top: 20rem;
  right: 20rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  opacity: 0.72;
  transition: opacity 0.2s ease, transform 0.2s ease;
  img {
    width: 16rem;
    height: 16rem;
    display: block;
  }
  &:hover {
    opacity: 1;
    transform: scale(1.04);
  }
  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 28rem;
    height: 28rem;
    top: 10rem;
    right: 10rem;
    img {
      width: 16rem;
      height: 16rem;
    }
  `};
`;
export function ModalCloseButton({ onDismiss }) {
    return (_jsx(CloseIconButton, { type: "button", "aria-label": "Close transaction modal", onClick: onDismiss, children: _jsx("img", { src: CloseImg, alt: "" }) }));
}
export function LoadingView({ children, onDismiss, message = 'Please confirm this transaction in your wallet.' }) {
    return (_jsxs(ConfirmOrLoadingWrapper, { children: [_jsx(ModalCloseButton, { onDismiss: onDismiss }), _jsxs("div", { className: "content", children: [children, _jsx("div", { className: "text", children: message })] })] }));
}
const WaitText = styled.div `
  font-family: var(--netx-font);
font-weight: 600;
font-size: 16rem;
color: #FFFFFF;
line-height: 20rem;
margin: 22rem 0 12rem;
${({ theme }) => theme.mediaWidth.upToSmall `
    font-weight: 600;
    font-size: 14rem;
    color: #FFFFFF;
    line-height: 18rem;
    margin: 16rem 0 8rem;
    
  `};
`;
const JumpIcon = styled.span `
display: inline-block;
    width: 16rem;
    height: 16rem;
    background: url(${JumpImg});
    background-size: 100% 100%;
    margin-left: 8rem;
    ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 12rem;
    height: 12rem;
    margin-left: 6rem;
  `};
`;
const fallbackChainInfo = {
    1: {
        scanName: 'Etherscan',
        scanLink: 'etherscan.io',
    },
    97: {
        scanName: 'BscScan',
        scanLink: 'testnet.bscscan.com',
    },
    56: {
        scanName: 'BscScan',
        scanLink: 'bscscan.com',
    },
    137: {
        scanName: 'PolygonScan',
        scanLink: 'polygonscan.com',
    },
    345: {
        scanName: 'TSCScan',
        scanLink: 'https://www.tscscan.io',
    },
    11155111: {
        scanName: 'Etherscan',
        scanLink: 'sepolia.etherscan.io',
    },
    80002: {
        scanName: 'PolygonScan',
        scanLink: 'amoy.polygonscan.com',
    },
};
const defaultChainId = Number(walletConfig.chains[0]?.id) || 345;
function normalizeExplorerBaseUrl(url) {
    return url.startsWith('http') ? url : `https://${url}`;
}
function getChainInfo(chainId) {
    const numericChainId = Number(chainId);
    const activeChain = walletConfig.chains.find((chain) => chain.id === numericChainId);
    const explorer = activeChain?.blockExplorers?.default;
    if (explorer?.name && explorer?.url) {
        return {
            scanName: explorer.name,
            scanLink: explorer.url
        };
    }
    return fallbackChainInfo[numericChainId] || fallbackChainInfo[defaultChainId] || fallbackChainInfo[345];
}
function getExplorerLink(chainId, data, type) {
    const chainInfo = getChainInfo(chainId);
    const prefix = normalizeExplorerBaseUrl(chainInfo.scanLink);
    switch (type) {
        case 'transaction': {
            return `${prefix}/tx/${data}`;
        }
        case 'token': {
            return `${prefix}/token/${data}`;
        }
        case 'block': {
            return `${prefix}/block/${data}`;
        }
        case 'address':
        default: {
            return `${prefix}/address/${data}`;
        }
    }
}
export function SubmittedView({ children, onDismiss, hash, chainId, hideLink, isError }) {
    const currentChainId = useChainId();
    const activeChainId = chainId || currentChainId || defaultChainId;
    const chainInfo = getChainInfo(activeChainId);
    return (_jsxs(ConfirmOrLoadingWrapper, { children: [_jsx(ModalCloseButton, { onDismiss: onDismiss }), _jsxs("div", { className: "scanText", children: [children, _jsx(WaitText, { children: "Transaction submitted" }), !hideLink && !isError && hash && (_jsxs(ExternalLink, { href: getExplorerLink(activeChainId, hash, 'transaction'), children: ["View on ", chainInfo.scanName, " ", _jsx(JumpIcon, { "aria-hidden": "true" })] }))] })] }));
}
